import React from 'react';
import PropTypes from 'prop-types';
import style from './scan-details.module.less';

export const ScanDetails = ({ renderLeft, renderRight }) => {
  return (
    <div className={style['body-layout']}>
      <div className={style.left}>{renderLeft && renderLeft()}</div>
      <div className={style.right}>{renderRight && renderRight()}</div>
    </div>
  );
};

ScanDetails.propTypes = {
  renderLeft: PropTypes.func,
  renderRight: PropTypes.func,
};
